import { render } from "./App.vue?vue&type=template&id=21f5bd7e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=21f5bd7e&lang=scss"

import exportComponent from "E:\\Work\\客户管理系统\\Code\\glory-crm\\FrontEndCode\\glory_crm_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__